export enum ClientCommands {
    CLICK_GOOGLE_PLAY_ICON = 'clickgoogleplayicon',
    COMMAND_ERROR = 'onError',
    CONSENT_STATE = 'consentState',
    ENABLE_SOUND = 'enableSound',
    PASTE_CLIPBOARD_CONTENT = 'pasteClipboardContent',
    PAY_FINISH = 'payFinish',
    POLL_RESPONSE = 'pollingResponse',
    SET_FACEBOOK_ACCESS_TOKEN = 'setFacebookAccessToken',
    SET_GOOGLE_ACCESS_TOKEN = 'setGoogleAccessToken',
    SET_IS_GROUP_MEMBER = 'setIsGroupMember',
    SET_KEYBOARD_ENABLED = 'setKeyboardEnabled',
    SET_CONSENT_RESULT = 'setConsentResult',
    SET_START_DATA = 'setStartData',
    SET_START_SHORT_DATA = 'setStartShortData',
    SET_MAINTENANCE_DATA = 'setMaintenanceData',
    TEST_CALLBACK = 'testCallback',
    UPDATE_HAS_BOOKMARK_FLAG = 'updateHasBookmarkFlag',
    VIDEO_FINISHED = 'videoFinished',
    VIDEO_PART_FINISHED = 'videoPartFinished',
    PING_ME_IF_ALIVE = 'pingMeIfAlive',
    SET_CLIENT_NOTIFICATIONS_STATE = 'setClientNotificationsState',
    SET_CLIENT_NEW_NOTIFICATIONS_STATE = 'setClientNewNotificationsState',
    SET_CLIENT_NOTIFICATIONS_BROWSER_STATE = 'setClientNotificationsBrowserState',
    SET_TAB_STATE = 'setTabState',
    FINISH_ACCOUNT_LINKING_REWARD = 'finishAccountLinkingReward',
}
